import React from 'react';
import BillingEnrolmentForm from './components/BillingEnrolmentForm';
import { useLocation } from 'react-router-dom';
import AuthFormPage from './components/AuthFormPage';
import Markdown from '../../components/Markdown';
import Page from '../../components/Page.js';
import ContentContainer from '../../components/ContentContainer.js';
import {useContent} from '../../components/ContentProvider.js';

const ProviderActivatePage = () => {
  const content = useContent('/providers/billing/enroll') || {};
  const [complete, setComplete] = React.useState(false);
  const query = new URLSearchParams(useLocation().search);
  const code = query.get('code');
  if (!complete) {
    return (
      <AuthFormPage title="Clickability Provider Billing Enrolment">
        <BillingEnrolmentForm
          code={code}
          onComplete={() => {setComplete(true);}}
        />
      </AuthFormPage>
    );
  } else {
    return (
      <Page title={content.title}>
        <ContentContainer>
          <Markdown content={content.body}/>
        </ContentContainer>
      </Page>
    );
  }

};

export default ProviderActivatePage;
